import { getMessages } from '../../../../../../../../store/constants';

export const MY_WORK_IMPORT_BOARDS_TITLE = getMessages().getText('assigned_to_me.import.title');
export const MY_WORK_IMPORT_BOARDS_TEXT = getMessages().getText('assigned_to_me.import.text');
